const PREFIX = 'i18n:'

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value)
}

export function encodeNotificationText(key, parameters) {
  if (!key) {
    return
  }

  const entries = Object.entries(parameters ?? {}).filter(
    ([, value]) => value !== undefined && value !== null,
  )

  if (!entries.length) {
    return `${PREFIX}${key}`
  }

  return `${PREFIX}${key}:${JSON.stringify(Object.fromEntries(entries))}`
}

export function decodeNotificationText(value) {
  if (typeof value !== 'string' || !value.startsWith(PREFIX)) {
    return
  }

  const body = value.slice(PREFIX.length)
  const separator = body.indexOf(':')

  if (separator === -1) {
    return { key: body }
  }

  const key = body.slice(0, separator)

  try {
    const parsed = JSON.parse(body.slice(separator + 1))
    return isPlainObject(parsed) ? { key, params: parsed } : { key }
  }
  catch {
    return { key }
  }
}
